import { skipToken } from '@reduxjs/toolkit/query';
import Loader from 'components/Loader';
import { useIsNewDesign } from 'components/tables/list-table/filter-bar/useIsNewDesign';
import { useMemo } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useGetExperienceRecordByIdQuery } from 'store/api/experience-records.ts';
import { ExperienceRecordFormData } from 'types/experience-records.ts';
import { useClassifiers } from 'utils/useClassifiers';
import { experienceRecordDtoToForm } from './experienceRecordFormMapping';
import ExperienceRecordForm from './ExperienceRecordForm.tsx';

const ClassicExperienceRecordPageEdit = () => {
    const { id: experienceRecordId } = useParams();
    const {
        data: experienceRecord,
        isLoading,
        isError,
    } = useGetExperienceRecordByIdQuery(experienceRecordId ?? skipToken);

    const { classifiers, isLoading: isLoadingClassifiers } = useClassifiers({
        codes: ['CURRENCY', 'COUNTRY'],
    });

    const initialData = useMemo<ExperienceRecordFormData | undefined>(() => {
        if (experienceRecord && classifiers) {
            return experienceRecordDtoToForm(experienceRecord, classifiers);
        }
        return undefined;
    }, [classifiers, experienceRecord]);

    if (isLoading || isLoadingClassifiers || (initialData === undefined && !isError)) {
        return <Loader />;
    }

    return <ExperienceRecordForm type="edit" initialData={initialData} />;
};

/** In the new design an experience record is edited card by card on its page, so its edit URL opens Core details. */
const ExperienceRecordPageEdit = () => {
    const isNew = useIsNewDesign();
    const { id: experienceRecordId } = useParams();
    return isNew ? (
        <Navigate to={`/experience-records/${experienceRecordId}?edit=core-details`} replace />
    ) : (
        <ClassicExperienceRecordPageEdit />
    );
};

export default ExperienceRecordPageEdit;
